import React from 'react';
import { Scan, CreditCard, BatteryCharging, ArrowRight, Zap, MapPin } from 'lucide-react';
import { howItWorksData } from '../data/mock';

const iconMap = {
  scan: Scan,
  'credit-card': CreditCard,
  'battery-charging': BatteryCharging
};

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-20 bg-gradient-to-br from-yellow-50 via-white to-green-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Comment Ça Marche ?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Trois étapes simples pour ne plus jamais manquer de batterie
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 relative">
            {howItWorksData.map((step, index) => {
              const Icon = iconMap[step.icon];
              return (
                <React.Fragment key={step.step}>
                  <div className="relative">
                    <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 h-full border-2 border-transparent hover:border-yellow-300 group">
                      {/* Step number */}
                      <div className="absolute -top-4 -left-4 w-12 h-12 bg-yellow-500 rounded-full flex items-center justify-center shadow-lg">
                        <span className="text-xl font-bold text-gray-900">{step.step}</span>
                      </div>
                      
                      {/* Icon */}
                      <div className="w-16 h-16 bg-green-100 rounded-xl flex items-center justify-center mb-6 mx-auto group-hover:bg-green-500 group-hover:scale-110 transition-all duration-300">
                        <Icon className="w-8 h-8 text-green-600 group-hover:text-white transition-colors duration-300" />
                      </div>
                      
                      <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
                        {step.title}
                      </h3>
                      
                      <p className="text-gray-600 leading-relaxed text-center">
                        {step.description}
                      </p>
                    </div>
                  </div>
                  
                  {/* Arrow between steps (hidden on mobile and last item) */}
                  {index < howItWorksData.length - 1 && (
                    <div className="hidden md:flex items-center justify-center absolute top-1/2 transform -translate-y-1/2" style={{ left: `${(index + 1) * 33.33 - 8}%` }}>
                      <ArrowRight className="w-8 h-8 text-yellow-500" />
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>

        {/* Additional info */}
        <div className="mt-16 text-center space-y-4">
          <div className="inline-flex items-center gap-2 bg-white px-8 py-4 rounded-full shadow-md border border-yellow-200">
            <Zap className="w-5 h-5 text-yellow-600" />
            <p className="text-gray-700 font-medium">
              Temps moyen de transaction : <span className="text-yellow-600 font-bold">moins de 30 secondes</span>
            </p>
          </div>
          
          <div className="inline-flex items-center gap-3 bg-gradient-to-r from-green-50 to-yellow-50 px-8 py-4 rounded-full shadow-md border-2 border-green-300">
            <MapPin className="w-5 h-5 text-green-600" />
            <p className="text-gray-700 font-medium">
              <span className="font-bold text-green-700">Application mobile</span> avec carte interactive de toutes les bornes disponibles
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
